import { render, staticRenderFns } from "./AnswerText.vue?vue&type=template&id=6dc3491f"
import script from "./AnswerText.vue?vue&type=script&lang=js"
export * from "./AnswerText.vue?vue&type=script&lang=js"
import style0 from "./AnswerText.vue?vue&type=style&index=0&id=6dc3491f&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports